import React, { createContext, useEffect, useState } from "react";
import AuthenticationService from "../services/AuthenticationService";
import WalletService from "../services/WalletService";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userId, setUserId] = useState(-1);
  const [token, setToken] = useState(() => localStorage.getItem("token") || null);
  const [firebaseToken, setFirebaseToken] = useState(() => localStorage.getItem("firebaseToken") || null);
  const [role, setRole] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [walletCurrency, setWalletCurrency] = useState("USD");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }, [token]);

  useEffect(() => {
    if (firebaseToken) {
      localStorage.setItem("firebaseToken", firebaseToken);
    } else {
      localStorage.removeItem("firebaseToken");
    }
  }, [firebaseToken]);

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setUserId(-1);
        setRole(null);

        setWalletCurrency("USD");
        setLoading(false);
        return;
      }

      try {
        const response = await AuthenticationService.checkToken();
        setUserId(response.user.email || -1);
        setRole(response.user.role || null);

        const walletData = await WalletService.getUserWallet();
        // console.log("Wallet currency:", walletData?.currency);
        setWallet(walletData);
        if (walletData?.currency) {
          setWalletCurrency(walletData.currency);
        }
      } catch (error) {
        console.error("Token check failed:", error);
        setToken(null);
        setUserId(-1);
        setRole(null);
        setWalletCurrency("USD");
      } finally {
        setLoading(false);
      }
    };
    verifyToken();
  }, [token]);

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken,
        firebaseToken,
        setFirebaseToken,
        userId,
        setUserId,
        role,
        setRole,
        wallet,
        walletCurrency,
        setWalletCurrency,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
